import React from 'react';
import { Label } from './Utilities';
import DeepDiveOpenButton from './DeepDive/DeepDiveOpenButton';
import helpIcon from '../img/help-large.svg';
import speakerIcon from '../img/speaker-large.svg';

const HelpScreen = ({className="", modal="false"}) => {
  return (
    <div className={`text-center m-auto mobile:mt-8 absolute top-1/2 -translate-y-[50%] mobile:px-2 ${modal==="true" ? "mobile:max-w-[95%] scrollbars mobile:h-[calc(100%-75px)] mobile:overflow-y-auto " : ""}`}>

      <h2 className="text-white text-center text-[20px] md:text-[22px] font-bold mb-10 md:mb-24">
        Make this experience your own with these <span className="whitespace-nowrap">helpful tools</span>
      </h2>

      <ul className="grid md:grid-cols-2 md:grid-rows-2 gap-1 lg:gap-16 lg:gap-x-24 mobile:gap-y-8 max-w-[800px] m-auto">

        <li>
          <ul className="grid text-center">
            <li className="mobile:mb-4 md:min-h-[70px] bg-opacity-50 text-center">
              <DeepDiveOpenButton span={true} className="!relative !opacity-100 !bottom-0 !m-0 !block !m-auto !pointer-events-none !w-fit px-4">
                Deep dive
              </DeepDiveOpenButton>
            </li>
            <li>
              <Label className="max-w-[300px]">Press this button for extra insight into topics.</Label>
            </li>
          </ul>
        </li>


        <li>
          <ul className="grid text-center">
            <li className="mobile:mb-4 md:min-h-[70px] bg-opacity-50 text-center">
              <h3 className="text-[20px] text-white font-bold underline decoration-watermelon">MAC lung disease</h3>
            </li>
            <li>
              <Label className="max-w-[300px]">Press the underlined text to read a word’s definition.</Label>
            </li>
          </ul>
        </li>


        <li>
          <ul className="grid text-center">
            <li className="mobile:mb-4 md:min-h-[80px] bg-opacity-50 text-center">
              <img src={speakerIcon} alt="" className="block m-auto"/>
            </li>
            <li>
              <Label>Press this icon on the top right at any time to turn audio on or off.</Label>
            </li>
          </ul>
        </li>


        <li>
          <ul className="grid text-center">
            <li className="mobile:mb-4 md:min-h-[80px] bg-opacity-50 text-center">
              <img src={helpIcon} alt="" className="block m-auto"/>
            </li>
            <li>
              <Label className="max-w-[390px] mobile:pb-5">Press this icon on the top right at any time to revisit this page.</Label>
            </li>
          </ul>
        </li>

      </ul>
      
    </div>
  );
}

export default HelpScreen;
